import React from "react";
import { Box, Divider, Typography } from "./styles";
import { Button } from "../Button";

export interface TitleProps {
  label: string;
  isDivider: boolean;
  children?: React.ReactNode;
}

const Title = ({ label, isDivider, children }: TitleProps) => {
  return (
    <>
      <Box style={{ paddingTop: "10px", paddingBottom: "10px" }}>
        <Typography>{label}</Typography>
        {children}
      </Box>
      {isDivider && <Divider />}
    </>
  );
};

export default Title;
